import { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import ViewWeekIcon from '@mui/icons-material/ViewWeek'
import { useGridApiContext } from '@mui/x-data-grid-pro'
import { useAddViewMutation } from '../../../services/views/slice'

const SaveViewToolbar = () => {
  const [label, setLabel] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [isAddingView, setIsAddingView] = useState(false)

  const apiRef = useGridApiContext()
  const [addView] = useAddViewMutation()

  const handleLabelChange = (event) => {
    setIsValid(event.target.value?.trim()?.length > 0)
    setLabel(event.target.value)
  }

  const handleSubmitForm = (e) => {
    e.preventDefault()
    saveGridState()
    handleClose()
  }

  const handleClose = () => {
    setLabel('')
    setIsAddingView(false)
  }

  const saveGridState = () => {
    const state = apiRef.current.exportState()
    const gridState = {
      name: label.trim(),
      view: {
        columns: state.columns,
        filter: state.filter,
        sorting: state.sorting,
      },
    }

    return addView(gridState)
  }

  return (
    <>
      <Button size="small" startIcon={<ViewWeekIcon />} onClick={() => setIsAddingView(true)}>
        Save View
      </Button>
      <Dialog onClose={handleClose} open={isAddingView}>
        <form onSubmit={handleSubmitForm}>
          <DialogTitle width={300}>Save View</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              value={label}
              onChange={handleLabelChange} // Corrected onChange handler
              margin="dense"
              size="small"
              label="View name"
              variant="standard"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button type="button" color="error" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={!isValid}>
              Save View
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}

export default SaveViewToolbar
